import { render } from "./TrickRecommendationPrivateCard.vue?vue&type=template&id=68ef0698&scoped=true"
import script from "./TrickRecommendationPrivateCard.vue?vue&type=script&lang=js"
export * from "./TrickRecommendationPrivateCard.vue?vue&type=script&lang=js"

import "./TrickRecommendationPrivateCard.vue?vue&type=style&index=0&id=68ef0698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ef0698"]])

export default __exports__